// routes/WalletRoutes.jsx

import { Routes, Route, Navigate } from 'react-router-dom';
import WalletOverview    from '../pages/wallet/WalletOverview';
import WalletBalance     from '../pages/wallet/WalletBalance';
import AddMoney          from '../pages/wallet/AddMoney';
import Withdraw          from '../pages/wallet/withdraw';
import Transactions      from '../pages/wallet/transactions';
import PaymentMethods    from '../pages/wallet/paymentMethods';
import BankAccounts      from '../pages/wallet/AddMoney';
import Cards             from '../pages/wallet/cards';
import RecurringPayments from '../pages/wallet/recurring';

import Invoices          from '../pages/wallet/invoices';
import Rewards           from '../pages/wallet/rewards';
import Statements        from '../pages/wallet/statements';
import LimitsKyc         from '../pages/wallet/limits';
import KeyWallet         from '../pages/wallet/KeyWallet';

const WalletRoutes = () => (
  <Routes>
    {/* Default → overview */}
    <Route index element={<Navigate to="overview" replace />} />

    {/* ── Core wallet ───────────────────────────────────────── */}
    <Route path="overview"         element={<WalletOverview />} />
    <Route path="balance"          element={<WalletBalance />} />
    <Route path="add-money"        element={<AddMoney />} />
    <Route path="withdraw"         element={<Withdraw />} />
    <Route path="transactions"     element={<Transactions />} />

    {/* ── Payment instruments ───────────────────────────────── */}
    <Route path="payment-methods"  element={<PaymentMethods />} />
    <Route path="bank-accounts"    element={<BankAccounts />} />
    <Route path="cards"            element={<Cards />} />
    <Route path="recurring"        element={<RecurringPayments />} />

    {/* ── Invoices ──────────────────────────────────────────── */}
    <Route path="invoices"         element={<Invoices />} />

    {/* ── Key Wallet (new) ──────────────────────────────────── */}
    <Route path="keys"             element={<KeyWallet />} />

    {/* ── Extras ────────────────────────────────────────────── */}
    <Route path="rewards"          element={<Rewards />} />
    <Route path="statements"       element={<Statements />} />
    <Route path="limits"           element={<LimitsKyc />} />

    {/* Fallback */}
    <Route path="*" element={<Navigate to="overview" replace />} />
  </Routes>
);

export default WalletRoutes;
